import React, { Component } from 'react';
import PropTypes from 'prop-types';

import branch from 'client/core/branch';
import log from 'client/lib/log';
import postWithState from 'client/actions/postWithState';

import { SR_API_ACTION_HOUSEHOLD_NOTE_SHARE } from 'api/actionTypes';

import SrCreateNoteForm from 'client/components/SrCreateNoteForm';
import SrNotesList, { SR_HOUSEHOLD_NOTES } from 'client/components/SrNotesList';
import SrHouseholdNoteShareModal from 'client/components/SrHouseholdNoteShareModal';

@branch({
  currentUser: ['currentUser'],
})
class SrHouseholdNotesContainer extends Component {
  static propTypes = {
    household: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    reloadDataTable: PropTypes.func.isRequired,
    currentUser: PropTypes.object.isRequired,
    openedInModal: PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      shareHouseholdNote: null,
    };
  }

  componentDidMount() {
    const { household } = this.props;
    if (!household) {
      const error = new Error(
        'Trying to render a `SrHouseholdNotesContainer` without an active household.',
      );
      error.name = 'SrHouseholdNotesContainerWithoutActiveHouseholdError';
      log.error(error);
    }
  }

  _onClickShareNote = (householdNote) => {
    this.setState({
      shareHouseholdNote: householdNote,
    });
  };

  _onClose = () => {
    this.setState({
      shareHouseholdNote: null,
    });
  };

  _onSubmit = (formValues) => {
    const { dispatch, reloadDataTable } = this.props;

    const { shareHouseholdNote } = this.state;

    dispatch(postWithState, {
      action: SR_API_ACTION_HOUSEHOLD_NOTE_SHARE,
      payload: {
        householdNoteId: shareHouseholdNote.id,
        listingIds: formValues.listingIds,
      },
    }).then(() => {
      reloadDataTable();
      this._onClose();
    });
  };

  render() {
    const { household, dispatch, reloadDataTable, currentUser, openedInModal } = this.props;

    const { shareHouseholdNote } = this.state;

    return (
      <div className="SrHouseholdNotesContainer">
        {household && (
          <div>
            <SrNotesList
              type={SR_HOUSEHOLD_NOTES}
              notes={household.notes}
              dispatch={dispatch}
              reloadDataTable={() => reloadDataTable()}
              currentUser={currentUser}
              openedInModal={openedInModal}
              onClickShareNote={this._onClickShareNote}
            />
            <SrCreateNoteForm
              householdId={household.id}
              dispatch={dispatch}
              reloadDataTable={() => reloadDataTable()}
              onNoteCreated={(note) =>
                this._onClickShareNote({
                  ...note,
                  householdSharedListingNotes: [],
                })
              }
            />
          </div>
        )}

        {shareHouseholdNote && (
          <SrHouseholdNoteShareModal
            listingsApplyingFor={(household.listingApplications || []).map(
              ({ listing }) => listing,
            )}
            shareHouseholdNote={shareHouseholdNote}
            onClose={this._onClose}
            onSubmit={this._onSubmit}
          />
        )}
      </div>
    );
  }
}

SrHouseholdNotesContainer.displayName = 'SrHouseholdNotesContainer';

export default SrHouseholdNotesContainer;
